import { useSelector } from "react-redux";
import type { RootState } from "@/store";

export function useBookShipment2Slice() {
  return useSelector((state: RootState) => state.bookShipment);
}
